// Columna "quién subió": carita + nombre, o "No registrado" con su explicación.
import React from "react";
import { Tooltip, Typography } from "antd";
import { UserCell } from "../../../Components/UserAvatar";
import type { SubidoPor } from "../../../services/almacenamiento.api";

const { Text } = Typography;

/** Solo los roles con login llevan carita (CLAUDE.md §7). */
const ROLES_CON_LOGIN = ["cliente", "aseador", "administrador", "superadministrador"];

export const TEXTO_NO_REGISTRADO =
  "Los archivos subidos antes de esta versión no guardan quién los subió. Solo los nuevos llevan autor.";

const SubidoPorCell: React.FC<{ subidoPor: SubidoPor | null; size?: number }> = ({
  subidoPor,
  size = 28,
}) => {
  if (!subidoPor) {
    return (
      <Tooltip title={TEXTO_NO_REGISTRADO}>
        <Text type="secondary">No registrado</Text>
      </Tooltip>
    );
  }
  return (
    <UserCell
      nombre={subidoPor.nombre}
      avatarUrl={subidoPor.avatar_url}
      avatarSeed={subidoPor.avatar}
      withAvatar={ROLES_CON_LOGIN.includes(subidoPor.rol)}
      size={size}
    />
  );
};

export default SubidoPorCell;
